export const CURRENCIES = <const>['EUR', 'GBP'];

export type CurrencyCode = (typeof CURRENCIES)[number];

export const DEFAULT_CURRENCY: CurrencyCode = 'EUR';
